module.exports = __webpack_public_path__ + "media/images/logo-799cc6b9049e7e56d573120ec02c5eb5.svg";